import React from "react";
import styles from "../LifeFocus/LifeFocus.module.css";
import { useNavigate } from "react-router-dom";
const LifeFocus = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={styles.containerBox}>
        <div className={styles.lifeimg}>
          <img
            loading="lazy"
            src="Images/Life-in focus.webp"
            alt="content man and woman on beach watching the sunrise"
           decoding="async" />

          <div className={styles.LifeFocusText}>
            <p>Life,</p>
            <p>in focus</p>
          </div>
        </div>
      </div>
      <div className={styles.partsection}>
        <div className={styles.section1} onClick={() => navigate("/edof")}>
          <img
            loading="lazy"
            src="Images/inovation.webp"
            alt="thoughtful person silhouetted against the reflection of sunset on a lake"
           decoding="async" />
          <p>Innovation</p>
        </div>
        <div
          className={styles.section1}
          onClick={() => navigate("/our-company")}
        >
          <img
            loading="lazy"
            src="Images/leadership.webp"
            alt="happy woman in meadow viewing distant mountains"
          decoding="async" />
          <p>Our Company</p>
        </div>
        <div className={styles.section1} onClick={() => navigate("/news-room")}>
          <img
            loading="lazy"
            src="Images/news.webp"
            alt="active woman jogger running on a sand dune"
           decoding="async" />
          <p>Newsroom</p>
        </div>
      </div>
    </>
  );
};

export default LifeFocus;
